import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import "./ChatInput.scss";
import ChatInputEmojiBox from "./ChatInputEmojiBox";
import { dispatchThunk } from "@/store/dispatchThunk";
import { sendMessage } from "@/store/chat/messages/Actions";
import LazyImageUploader from "../ImageUploader/LazyImageUploader";
import ChatInputTextArea from "./ChatInputTextArea";
import OutsideAlerter from "@/components/Generic/OutsideAlerter";
import { getOriginalImage } from "@/common/utils";
import { Icon } from "@/assets/sprites/icon";
import { assert } from "@/common/assert";

var ChatInput =
/** @class */
function (_super) {
  __extends(ChatInput, _super);

  function ChatInput(props) {
    var _this = _super.call(this, props) || this;

    _this.onOpenEmojiBox = function () {
      _this.setState({
        showEmojiBox: !_this.state.showEmojiBox
      });
    };

    _this.onSimpleEmojiClicked = function (emoji) {
      if (_this.chatInputTextArea) {
        _this.chatInputTextArea.appendEmoji(emoji);
      }
    };

    _this.onImageUploaded = function (image) {
      assert(image.url, "image url falsy!");
      var msg = {
        to: _this.props.contact,
        type: "image",
        imageUrl: getOriginalImage(image.url)
      };
      dispatchThunk(_this.props.store, sendMessage(msg));
    };

    _this.setChatInputTextArea = function (inst) {
      _this.chatInputTextArea = inst;
    };

    _this.onClickedOutsideEmojiBox = function () {
      _this.setState({
        showEmojiBox: false
      });
    };

    _this.state = {
      showEmojiBox: false
    };
    return _this;
  }

  ChatInput.prototype.render = function () {
    return _jsxs("div", __assign({
      className: "chat-input-area"
    }, {
      children: [_jsxs("ul", __assign({
        className: "chat-input-area__menus"
      }, {
        children: [_jsx("li", {
          children: _jsx("span", __assign({
            className: "chat-input-area__menu-item " + Icon["select-emoji"],
            onClick: this.onOpenEmojiBox,
            title: "\u70B9\u51FB\u9009\u62E9\u8868\u60C5"
          }, {
            children: this.state.showEmojiBox && _jsx(OutsideAlerter, __assign({
              onClickedOutside: this.onClickedOutsideEmojiBox
            }, {
              children: _jsx(ChatInputEmojiBox, {
                onSimpleEmojiClicked: this.onSimpleEmojiClicked
              }, void 0)
            }), void 0)
          }), void 0)
        }, void 0), _jsx("li", {
          children: _jsx(LazyImageUploader, __assign({
            onImageUploaded: this.onImageUploaded,
            uploadingUI: _jsx("span", {
              className: "chat-input-area__image-uploader chat-input-area__image-uploader--uploading"
            }, void 0)
          }, {
            children: _jsx("span", {
              className: "chat-input-area__image-uploader icon " + Icon["upload-image"],
              title: "\u70B9\u51FB\u53D1\u5E03\u56FE\u7247\uFF0C\u6216\u8005\u62D6\u62FD\u7167\u7247\u8FDB\u5165\u8F93\u5165\u6846"
            }, void 0)
          }), void 0)
        }, void 0)]
      }), void 0), _jsx(ChatInputTextArea, {
        ref: this.setChatInputTextArea,
        onImageUploaded: this.onImageUploaded
      }, void 0)]
    }), void 0);
  };

  return ChatInput;
}(React.Component);

export default ChatInput;